import { useState } from 'react';
import { PageHeader } from '@/components/common/PageHeader';
import { Tabs } from '@/components/common/Tabs';
import { LiveMonitoringTab } from './LiveMonitoringTab';
import { NotificationsTab } from './NotificationsTab';
import './feedMonitoring.css';

type TabKey = 'live' | 'notifications';

export function FeedMonitoringPage() {
  const [tab, setTab] = useState<TabKey>('live');
  // Lazy mount: Notifications fetches only after it is first opened.
  const [notificationsSeen, setNotificationsSeen] = useState(false);

  return (
    <div className="feed-monitoring-page">
      <PageHeader title="Feed Monitoring" breadcrumb={['Home', 'Feed Monitoring']} />

      <div className="card custom-card mb-2">
        <div className="card-header p-0">
          <Tabs
            variant="underline"
            tabs={[
              { key: 'live', title: 'Live Monitoring' },
              { key: 'notifications', title: 'Notifications' },
            ]}
            active={tab}
            onChange={(k) => {
              const key = k as TabKey;
              if (key === 'notifications') setNotificationsSeen(true);
              setTab(key);
            }}
          />
        </div>
        <div className="card-body">
          <div style={{ display: tab === 'live' ? 'block' : 'none' }}>
            <LiveMonitoringTab />
          </div>
          {notificationsSeen && (
            <div style={{ display: tab === 'notifications' ? 'block' : 'none' }}>
              <NotificationsTab />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
